import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendLike, sendLikeDonneurOrdre } from "../../redux/actions/likeActions";
import { sendDislike } from "../../redux/actions/dislikeActions";
import PrestataireCardLike from "../PrestataireCardLike";

const PrestatairesForDonneurOrdreDashboard = ({appelOffre}) => {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth || {});
  const apiUrl = process.env.REACT_APP_API_URL;

  const projects = user?.profilDonneurOrdre?.listProjetsDonneurOrdre || [];

  const [selectedProject, setSelectedProject] = useState(null);
  const [prestataire, setPrestataire] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  // 🔹 Charger un prestataire aléatoire pour un projet donné
  const fetchRandomPrestataire = async (appelOffre) => {
    if (!appelOffre?.idProjet) return;
    setLoading(true);
    setPrestataire(null);
    setMessage("");

    try {
      const res = await fetch(
        `${apiUrl}/api/random/prestataire?idProjet=${appelOffre.idProjet}`,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();
      if (data.success) {
        setPrestataire(data.prestataire);
      } else {
        setMessage(data.message || data.error || "Erreur serveur");
      }
    } catch (error) {
      console.error("Erreur fetch prestataire :", error);
      setMessage("Erreur lors du chargement du prestataire.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    fetchRandomPrestataire(appelOffre)
  },[appelOffre]);
  // 🔹 Gestion du like
  const handleLike = () => {
    if (!prestataire || !appelOffre) return;

    dispatch(sendLikeDonneurOrdre(appelOffre.idProjet, prestataire.idPrestataire, token));
    fetchRandomPrestataire(appelOffre);
  };

  // 🔹 Gestion du pass
  const handlePass = () => {
    if (!prestataire || !appelOffre) return;

    dispatch(sendDislike(prestataire.idUser, appelOffre.idProjet, token));
    fetchRandomPrestataire(appelOffre);
  };

  return (
    <div className="prestataires-dashboard">
      <h3>Trouver un prestataire compatible</h3>

      {loading && <p className="status">Chargement...</p>}

      {!loading && prestataire && appelOffre && (
        <PrestataireCardLike
          prestataire={prestataire}
          projet={appelOffre} 
          apiUrl={apiUrl}
          onLike={handleLike}
          onPass={handlePass}
        />
      )}

      {!loading && !prestataire && message&& (
        <div className="empty">
          <p>{message}</p>
          {appelOffre && (
            <button className="reload" onClick={() => fetchRandomPrestataire(appelOffre)}>
              🔄 Recharger
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default PrestatairesForDonneurOrdreDashboard;
